module.exports = __webpack_public_path__ + "img/fin_02_空壳行走.f3bd2fe4.jpg";